/**
 * Created by bladron on 07/04/16.
 */
import Reflux from 'reflux';
import { LocalityApi } from "../api/Api";

let LocalityActions = {
    getNearestLocalities: Reflux.createAction({asyncResult: true})
};

LocalityActions.getNearestLocalities.preEmit = (name, latitude, longitude, cb) => {
    LocalityApi.getNearestLocalities({ name: name, latitude: latitude, longitude: longitude }).then( (localities) => {
        cb(localities);
    });
};

export default LocalityActions;



// WEBPACK FOOTER //
// ./js/mywort/commons/actions/LocalityActions.js